import { initMacros } from './console-log.macros';

export function plugIn(editor: monaco.editor.IStandaloneCodeEditor) {
  initMacros(editor);
}
